import * as React from 'react';
import {Button, Cluster, Cover, Dialog, Heading, Icon, Notification, Stack, Table, Template} from '@pluto-tv/assemble';
import {IDismissedTimeline} from 'features/channelTimelines/channelTimelinesApi';
import {formatDateWithLocalTimezone} from 'utils/dateUtils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  dismissed: IDismissedTimeline[];
}

const renderDismissedTable = (dismissed: IDismissedTimeline[]) => {
  if (!dismissed.length) return null;

  return (
    <Table
      wrapContent={true}
      fixedHeader={true}
      cols={[
        {
          label: 'Start at',
          transform: row => formatDateWithLocalTimezone(new Date(row.start), 'MMM d, yyyy h:mm a'),
        },
        {
          label: 'End at',
          transform: row => formatDateWithLocalTimezone(new Date(row.stop), 'MMM d, yyyy h:mm a'),
        },
      ]}
      rows={dismissed}
    ></Table>
  );
};

const DismissedEpisodeModal = React.memo(({isOpen = false, onClose, dismissed}: Props) => (
  <Dialog isOpen={isOpen} onClose={onClose} width='54rem' height='48rem'>
    <Template label='header'>
      <Heading level='h2'>
        <Icon icon='warning' color='warning' space='xxsmall'>
          Attention
        </Icon>
      </Heading>
    </Template>
    <Template label='body'>
      <Cover gutter='medium' coverTemplateHeight='100%' overflow='auto' scrolling={true}>
        <Template label='header'>
          <Stack space='medium'>
            <Notification type='warning'>
              The episode(s) scheduled in the following time slot(s) were deleted and now appear as gaps. Publishing
              will leave these slots empty.
            </Notification>
          </Stack>
        </Template>

        <Template label='cover'>{renderDismissedTable(dismissed)}</Template>
      </Cover>
    </Template>
    <Template label='footer'>
      <Cluster justify='space-between' align='end'>
        <div></div>
        <Cluster space='small'>
          <Button size='small' type='primary' onClick={onClose}>
            Continue
          </Button>
        </Cluster>
      </Cluster>
    </Template>
  </Dialog>
));

export default DismissedEpisodeModal;
